import {combineReducers} from 'redux'
import uiReducer from './uiReducer'
import userReducer from './userReducer'
import dayTypeReducer from './dayTypeReducer'
import dayMovementReducer from './dayMovementReducer'
import authorizationReducer from './userAuthorizationReducer'
import themeReducer from './themeReducer'

const rootReducer = combineReducers({
   uiState : uiReducer,
   userState: userReducer,
   dayTypeReducer: dayTypeReducer,
   dayMovementReducer: dayMovementReducer,
   authorizationReducer: authorizationReducer,
   themeState: themeReducer
});


export default rootReducer;